import { useFiltersModalContext } from 'components/FiltersModalProvider/FiltersModalProvider';
import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { CloseButton } from 'components/buttons/CloseButton/CloseButton';
import { useCallback } from 'react';

interface CloseModalButtonProps {
	testId: string;
	rootClass?: string;
	iconClass?: string;
}

export const CloseModalButton: React.FC<CloseModalButtonProps> = ({ testId, rootClass, iconClass }) => {
	const { setActiveFilter, resetSelectionToApplied } = useFiltersContext();
	const { setShowFiltersModal, resetNumberOfGuestsSelectionToApplied } = useFiltersModalContext();

	const handleCloseClick = useCallback(() => {
		resetSelectionToApplied();
		resetNumberOfGuestsSelectionToApplied();
		setActiveFilter(null);
		setShowFiltersModal(false);
	}, [resetSelectionToApplied, setActiveFilter, setShowFiltersModal, resetNumberOfGuestsSelectionToApplied]);

	return <CloseButton testId={testId} onClick={handleCloseClick} rootClass={rootClass} iconClass={iconClass} />;
};
